import React from 'react';
import AddPetitionForm from './addPetitionForm';


export default function AddPetition(){


    return(
        <div className="myPetitionPage addMyPetitionPage">
            <AddPetitionForm />
        </div>
    )
}